import App from "./App.vue";
import router from "./router/router";
import store from "./store/store";
import ElementUI from "element-ui";

import api from "./http/index";
import menuUtil from "./utils/index";
import "./directive/directives";
import url from "./interface/url";
import toolUtil from "./utils/toolUtil";
import timeUtil from "./utils/timeUtil";
import "./assets/icon/iconfont.css";
import VueScroll from "vuescroll";
import "vuescroll/dist/vuescroll.css";
import md5 from "js-md5";
import "./directive/permission/index";
import cloud from "./utils/cloud";
import message from "./utils/message";
import method from "./interface/method";
import Clipboard from "v-clipboard";
import tools from "./utils/tools";
import "@/utils/default-passive-events.js";
import i18n from "./utils/i18n";

const Vue = require("vue");
const Qs = require("qs");
const Cookie = require("js-cookie");
//  富文本编辑器
import { ElementTiptapPlugin } from "element-tiptap";
// 引入 ElementUI 样式
import "element-ui/lib/theme-chalk/index.css";
// 引入 import element-tiptap 样式
import "element-tiptap/lib/index.css";
import "animate.css";

Vue.use(ElementUI, {
  i18n: (key, value) => {
    return i18n.t(key, value);
  } // 让 Element UI 使用 vue-i18n
});

// 安装 element-tiptap 插件
Vue.use(ElementTiptapPlugin, {
  lang: "en" // 设置语言为英文
});

Vue.config.productionTip = false;
Vue.use(store);
Vue.use(VueScroll);
Vue.use(Clipboard);
Vue.prototype.$vuescrollConfig = {
  bar: {
    size: "4px",
    hoverStyle: true, // 移入鼠标就显示滚动条
    onlyShowBarOnScroll: false, // 是否只有滚动的时候才显示滚动条
    background: "hsla(220,4%,58%,.3)"
  }
};
import { VueJsonp } from "vue-jsonp";
Vue.use(VueJsonp);

Vue.prototype.$method = method;

Vue.use(api);
Vue.prototype.$qs = Qs;
Vue.prototype.$url = url;
Vue.prototype.$toolUtil = toolUtil;
Vue.prototype.$timeUtil = timeUtil;
Vue.prototype.$md5 = md5;
Vue.prototype.$cookies = Cookie;
Vue.prototype.$cloud = cloud;
Vue.prototype.$message = message;
Vue.prototype.$tools = tools;

router.beforeEach((to, from, next) => {
  if (to.name) {
    document.title = to.name;
  }
  if (to.path === "/login") {
    next();
  } else {
    if (Cookie.get("token")) {
      if (to.path === "/") {
        router.push("/main");
      } else {
        menuUtil.initMenu(router, store);
        next();
      }
    } else {
      router.push("/login");
    }
  }
});

new Vue({
  i18n,
  router,
  store,
  render: h => h(App)
}).$mount("#app");
